import React from 'react';

/**
 * Fortnight date range with prev/next arrows. Shows a pill to return to the current fortnight when viewing another.
 */
const FortnightRangeControl = ({
  formattedRangeFortnight,
  fortnightIndex,
  setFortnightIndex,
  onJumpToCurrent,
  className = '',
  rangeClassName = '',
}) => {
  const isCurrent = fortnightIndex === 0;

  const goToCurrent = () => {
    setFortnightIndex(0);
    if (onJumpToCurrent) {
      onJumpToCurrent();
    }
  };

  return (
    <div className={className}>
      <button
        type="button"
        className="phone-fortnight-arrow transfers-fortnight-arrow"
        onClick={() => setFortnightIndex((prev) => prev - 1)}
        aria-label="Previous fortnight"
      >
        ‹
      </button>
      <div className="transfers-fortnight-range-wrap">
        {!isCurrent && (
          <button
            type="button"
            className="transfers-fortnight-jump-pill"
            onClick={goToCurrent}
            aria-label="Go to this fortnight"
          >
            Go to this fortnight
          </button>
        )}
        <span className={`transfers-fortnight-range ${rangeClassName}`}>
          {formattedRangeFortnight}
        </span>
      </div>
      <button
        type="button"
        className="phone-fortnight-arrow transfers-fortnight-arrow"
        onClick={() => setFortnightIndex((prev) => prev + 1)}
        aria-label="Next fortnight"
      >
        ›
      </button>
    </div>
  );
};

export default FortnightRangeControl;
